import {
    Box,
    Container,
    Grid,
    Skeleton,
    Stack,
    styled,
    SwipeableDrawer,
    TextField,
    Typography,
    IconButton,
    Button,
    CircularProgress,
    Divider,
} from "@mui/material";
import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    limit,
    orderBy,
    query,
    serverTimestamp,
    setDoc,
    where,
} from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { UserAuth } from "../context/AuthContext";
import { auth, db } from "../firebase.config";
import CustomButton from "../Components/CustomButton";
import EventCard from "../Components/EventCard";
import Iconify from "../Components/Iconify";
import { sendPasswordResetEmail, signInWithEmailAndPassword } from "firebase/auth";
import { Facebook, Google } from "@mui/icons-material";
import { Variables } from "../context/VariableContext";
import CustomTextField from "../Components/CustomTextField";
import { Link, useNavigate } from "react-router-dom";
import logoImg from "../media/mainLogo Partners.png";

const SignIn = ({ }) => {
    const { user, signUp, handleFacebookSigin, handleGoogleSignIn } = UserAuth();
    const { openLogin, setOpenLogin } = Variables();
    const navigate = useNavigate();
    const [loading, setLoading] = React.useState(false);



    const [emailField, setEmail] = useState("");
    const [passwordField, setPassword] = useState("");
    const [confirmPasswordField, setConfirmPassword] = useState("");
    const [nomField, setNomField] = useState("");
    const [prenomField, setPrenomField] = useState("");
    const [error, setError] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [profileComplete, setProfileComplete] = useState(false);

    const validatePassword = (password) => {
        const minLength = password.length >= 8;
        const hasUpper = /[A-Z]/.test(password);
        const hasLower = /[a-z]/.test(password);
        const hasNumber = /[0-9]/.test(password);
        const hasSpecial = /[!@#$%^&*(),.?":{}|<>]/.test(password);
        return minLength && hasUpper && hasLower && hasNumber && hasSpecial;
    };

    const seConnecter = async () => {
        setError(false);
        setLoading(true);

        const safeEmail = emailField.toLowerCase().trim();
        const safePassword = passwordField.trim();
        const safeConfirm = confirmPasswordField.trim();
        const safeNom = nomField.trim();
        const safePrenom = prenomField.trim();

        if (!safeEmail || !safePassword || !safeConfirm || !safeNom || !safePrenom) {
            setError(true);
            setErrorMsg("Tous les champs sont obligatoires.");
            setLoading(false);
            return;
        }

        if (!validatePassword(safePassword)) {
            setError(true);
            setErrorMsg("Le mot de passe doit contenir au moins 8 caractères, une majuscule, une minuscule, un chiffre et un caractère spécial.");
            setLoading(false);
            return;
        }

        if (safePassword !== safeConfirm) {
            setError(true);
            setErrorMsg("Les mots de passe ne correspondent pas.");
            setLoading(false);
            return;
        }

        try {
            const user = await signUp(safeEmail, safePassword, safeNom, safePrenom);
            console.log("Utilisateur inscrit :", user);
            navigate('/home');
        } catch (err) {
            setError(true);
            setErrorMsg(err.message || "Une erreur est survenue.");
        }
        setLoading(false);
    };

    const finishProcess = async () => {
        setError(false);
        setLoading(true);

        const safeNom = nomField.trim();
        const safePrenom = prenomField.trim();
        const safePassword = passwordField.trim();
        const safeConfirm = confirmPasswordField.trim();

        if (!safeNom || !safePrenom || !safePassword || !safeConfirm) {
            setError(true);
            setErrorMsg("Tous les champs sont requis.");
            setLoading(false);
            return;
        }

        if (safePassword !== safeConfirm) {
            setError(true);
            setErrorMsg("Les mots de passe ne correspondent pas.");
            setLoading(false);
            return;
        }

        if (!validatePassword(safePassword)) {
            setError(true);
            setErrorMsg("Mot de passe trop faible.");
            setLoading(false);
            return;
        }

        try {
            const idToken = await user.getIdToken(); // 🔐 Auth token
            const response = await fetch("https://us-central1-event-86cbf.cloudfunctions.net/completeOnboarding", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${idToken}`
                },
                body: JSON.stringify({
                    nom: safeNom,
                    prenom: safePrenom,
                    password: safePassword
                })
            });

            const result = await response.json();

            if (response.status !== 200) throw new Error(result.message || "Erreur serveur");
            await signInWithEmailAndPassword(auth, user.email, safePassword);
            // ✅ Redirection
            navigate("/home");
        } catch (err) {
            setError(true);
            setErrorMsg(err.message);
        }

        setLoading(false);
    };


    useEffect(() => {
        const fetchProfile = async () => {
            if (!user) return;
            const snap = await getDoc(doc(db, "users", user.uid));
            if (snap.exists()) {
                const data = snap.data();
                console.log(data)
                setEmail(data.email);
                if (data.profileComplete === false) {
                    setProfileComplete(true)
                } else {
                    navigate('/home', { replace: true })
                }
                // setProfileComplete(data.profileComplete === true); // sécurise null ou undefined
            } else {
                setProfileComplete(false); // nouveau user
            }
        };
        fetchProfile();
    }, [user]);


    return (
        <Container>
            <Stack justifyContent="center" alignItems="center" spacing={1} sx={{ color: 'white' }} marginBottom={5}>
                <img width={70} src={logoImg} alt="choptonticket_logo" />
                <Typography variant="subtitle1">Inscrivez-vous</Typography>

                <Stack spacing={2} sx={{ border: '1px solid white', borderRadius: '7px', padding: 2, width: { xs: `90%`, sm: 600 } }}>
                    {error && <Typography color="error">{errorMsg}</Typography>}

                    <Stack spacing={1}>
                        <Typography>Email</Typography>
                        <CustomTextField type="email" value={emailField} onChange={(e) => setEmail(e.target.value)} disabled={profileComplete} fullWidth />
                    </Stack>

                    <Stack>
                        <Typography>Nom</Typography>
                        <CustomTextField type="text" value={nomField} onChange={(e) => setNomField(e.target.value)} />
                    </Stack>

                    <Stack>
                        <Typography>Prénom</Typography>
                        <CustomTextField type="text" value={prenomField} onChange={(e) => setPrenomField(e.target.value)} />
                    </Stack>

                    <Stack>
                        <Typography>Mot de passe</Typography>
                        <CustomTextField type="password" value={passwordField} onChange={(e) => setPassword(e.target.value)} />
                        <Typography variant="caption" color="red">
                            Minimum 8 caractères, 1 majuscule, 1 minuscule, 1 chiffre, 1 caractère spécial
                        </Typography>
                    </Stack>

                    <Stack>
                        <Typography>Confirmation du mot de passe</Typography>
                        <CustomTextField type="password" value={confirmPasswordField} onChange={(e) => setConfirmPassword(e.target.value)} />
                    </Stack>

                    <CustomButton type="primaire" buttonText={profileComplete ? 'Finaliser votre profile' : "S'Inscrire"} onClick={setProfileComplete ? finishProcess : seConnecter} />

                    {!profileComplete && (
                        <>
                            <Divider>ou</Divider>

                            <Button
                                onClick={handleGoogleSignIn}
                                variant="outlined"
                                startIcon={<Google />}
                                sx={{ borderRadius: 2, color: '#DB4437', borderColor: '#DB4437', textTransform: 'none' }}
                            >
                                S'inscrire avec Google
                            </Button>

                            <Button
                                onClick={handleFacebookSigin}
                                variant="outlined"
                                startIcon={<Facebook />}
                                sx={{ borderRadius: 2, color: '#1877F2', borderColor: '#1877F2', textTransform: 'none' }}
                            >
                                S'inscrire avec Facebook
                            </Button>
                        </>
                    )}


                </Stack>
                {!profileComplete && (
                    <Stack direction="row" justifyContent="center" mt={2}>
                        <Typography variant="body2" color="white">
                            Déjà un compte ?{" "}
                            <Link to="/login" style={{ color: "#90caf9", textDecoration: "underline" }}>
                                Connectez-vous
                            </Link>
                        </Typography>
                    </Stack>
                )}

            </Stack>
        </Container>
    );
};

export default SignIn;


